var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIspNameIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C10.5711 16 12.25 12.6421 12.25 8.5C12.25 4.35786 10.5711 1 8.5 1C6.42893 1 4.75 4.35786 4.75 8.5C4.75 12.6421 6.42893 16 8.5 16Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1V16",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.25C12.6421 12.25 16 10.5711 16 8.5C16 6.42893 12.6421 4.75 8.5 4.75C4.35786 4.75 1 6.42893 1 8.5C1 10.5711 4.35786 12.25 8.5 12.25Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5H1",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIspNameIconBlue);
export default __webpack_public_path__ + "static/media/IspNameIconBlue.4f33b52e2a5e0ad0c4f0d99e52789ada.svg";
export { ForwardRef as ReactComponent };